"use strict";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect() {
    this.update();
  }
  update() {
    const stuck = window.scrollY > 0 && this.element.getBoundingClientRect().top <= 0;
    this.element.dataset.stuck = String(stuck);
  }
}
